import * as cmMessageTypes from '../../consts/communicationLayer/cmMessageTypes';
import devicePreSyncPingScheduler from '../device/devicePreSyncPingScheduler';
import cmFwuMessageResponseHandlers from './cmFwuMessageResponseHandlers';
import cmMessageResponseHandlers from './cmMessageResponseHandlers';

const onCmMessage = async (message, isHolder) => {
    const {type} = message;

    devicePreSyncPingScheduler.stopPing();

    switch (type) {
        case cmMessageTypes.STATUS_CHARACTERISTICS:
            cmMessageResponseHandlers.onStatusCharacteristicHandler(message);
            break;
        case cmMessageTypes.CYCLE_REQUESTS:
            cmMessageResponseHandlers.onCycleRequestHandler(message);
            break;
        case cmMessageTypes.FIRMWARE_UPDATE_PACKAGE_LOAD:
            cmFwuMessageResponseHandlers.onFirmwareUpdatePackageLoadHandler(message, isHolder);
            break;
        case cmMessageTypes.FIRMWARE_UPDATE_START:
            cmFwuMessageResponseHandlers.onFirmwareUpdateStartHandler(message, isHolder);
            break;
        case cmMessageTypes.CANCELLATION:
            cmMessageResponseHandlers.onCancelRequestHandler(message, isHolder);
            break;
        default:
            cmMessageResponseHandlers.defaultHandler(message, isHolder);
    }
};

export default {
    onCmMessage,
};
